module.exports = __webpack_public_path__ + "img/2b612d0.png";